import { AppShell } from "@mantine/core";
import { MainNav } from "./Sidebar/MainNav";
import { ModalsProvider } from "@mantine/modals";
import './MainLayout.css';  // Import the external CSS file
import { useState } from "react";
import { BgColorRouteContext } from "../../context/BgColorContext";

export const MainLayout = (props: any) => {
  const [bgColor, setBgColor] = useState("#F8F8FB");
  const [pageName, setPageName] = useState("idea");

  // Determine the classes to apply based on bgColor
  const containerClass =
    pageName === "idea"
      ? ""
      : pageName === "AiIdeaPage"
        ? "responsive-container-ai"
        : pageName === "discovery" || pageName === "dashboard"
          ? "responsive-container responsive-container-discovery"
          : "responsive-container";
  const contentWrapperClass =
    pageName === "idea"
      ? ""
      : pageName === "AiIdeaPage"
        ? "responsive-content-wrapper-ai"
        : pageName === "discovery" || pageName === "dashboard"
          ? "responsive-content-wrapper responsive-content-wrapper-discovery"
          : "responsive-content-wrapper";

  return(
    <AppShell
      padding={0}
      navbar={<MainNav />}
      styles={{
        main: {
          backgroundColor: bgColor,
          overflowX: "hidden",
          overflowY: "auto",
          minWidth: 0,
          minHeight: 0,
          width: "auto",
          maxWidth: "100%",
        },
        body: {
          height: "100vh",
          minWidth: 0,
          overflowX: "hidden",
          overflowY: "hidden",
        },
      }}
    >
      <BgColorRouteContext.Provider value={{ setBgColor, setPageName }}>
        <div className={containerClass}>
          <div className={contentWrapperClass}>
            <ModalsProvider labels={{ confirm: "Submit", cancel: "Cancel" }}>
              {props.children}
            </ModalsProvider>
          </div>
        </div>
      </BgColorRouteContext.Provider>
    </AppShell>
  )
};
